export default {
  'movementDirectSale.label.filteByDate': 'Filter by date from',
  'movementDirectSale.label.situation': 'Situation',
  'movementDirectSale.label.reportType': 'Select report type',
  'movementDirectSale.label.groupReportBy': 'Group report by',
  'movementDirectSale.label.customers': 'Customers',
  'movementDirectSale.label.seller': 'Seller',
  'movementDirectSale.label.tags': 'Tags direct sale',
  'movementDirectSale.label.moreOptions': 'More Options',

  'movementDirectSale.option.sale': 'Sale',
  'movementDirectSale.option.authorization': 'Authorization',
  'movementDirectSale.option.cancellation': 'Cancellation',
  'movementDirectSale.option.createDate': 'Create Date',
  'movementDirectSale.option.open': 'Open',
  'movementDirectSale.option.authorized': 'Authorized',
  'movementDirectSale.option.canceled': 'Canceled',
  'movementDirectSale.option.salesSummary': 'Sales Summary',
  'movementDirectSale.option.totalBySales': 'Total by Sales',
  'movementDirectSale.option.seller': 'Seller',
  'movementDirectSale.option.situation': 'Situation',
  'movementDirectSale.option.diary': 'Diary',
  'movementDirectSale.option.monthly': 'Monthly',

  'movementDirectSale.checkbox.synthetic': 'Synthetic',

  'movementDirectSale.button.selectCustomers': 'Select Customers',
};
